import * as React from "react"

const IncomeIcon = ({...props}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 3"
    viewBox="0 0 64 64"
    {...props}
  >
    <path
      fill="#785d55"
      d="M2 42v-4a2.006 2.006 0 0 1 2-2h16a2.006 2.006 0 0 1 2 2v2Z"
    />
    <path
      fill="#644e48"
      d="M20 39H4a2.006 2.006 0 0 0-2 2v1l19.735-1.974A2 2 0 0 0 20 39Z"
    />
    <path
      fill="#e3a22d"
      d="M39 28a9 9 0 1 1-9-9 9.034 9.034 0 0 1 8.82 7.18A9.134 9.134 0 0 1 39 28Z"
    />
    <circle cx={30} cy={28} r={7} fill="#f9d157" />
    <path
      fill="#e3a22d"
      d="M30 27a1 1 0 1 1 1-1h2a3 3 0 0 0-2-2.816V22h-2v1.184A2.993 2.993 0 0 0 30 29a1 1 0 1 1-1 1h-2a3 3 0 0 0 2 2.816V34h2v-1.184A2.993 2.993 0 0 0 30 27Z"
    />
    <rect width={28} height={22} x={2} y={40} fill="#785d55" rx={2} />
    <path
      fill="#876e65"
      d="M28 40H4v18a2.006 2.006 0 0 0 2 2h24V42a2.006 2.006 0 0 0-2-2Z"
    />
    <path fill="#644e48" d="M30 48h-9a3 3 0 0 0-3 3 3 3 0 0 0 3 3h9" />
    <path fill="#a9b0b6" d="M54 2h8v16h-8z" />
    <path
      fill="#468f43"
      d="M58 36v5a13 13 0 0 1-13 13v3l-10-6 10-6v3a7 7 0 0 0 7-7v-5Z"
    />
    <path
      fill="#e1b1a9"
      d="M54 3v13h-3a10.973 10.973 0 0 1-7.18 6.48L42 23l-3.18 3.18a2.828 2.828 0 0 1-3.99-4.01L39 18l-1-4-5-1-3 3v3a9 9 0 0 0-6 2.29V14a5.22 5.22 0 0 1 1.33-3.49l5.34-6.02A4.466 4.466 0 0 1 34 3Z"
    />
    <path
      fill="#ffe1d4"
      d="m30.67 6.49-5.34 6.02A5.22 5.22 0 0 0 24 16v5.29A9 9 0 0 1 30 19v-3l3-3 5 1 1 4-4.17 4.17a2.828 2.828 0 0 0 3.99 4.01L42 23l1.82-.52A10.973 10.973 0 0 0 51 16h3V5H34a4.466 4.466 0 0 0-3.33 1.49Z"
    />
    <path fill="#c9cacc" d="M54 5h8v13h-8z" />
    <path
      fill="#58b15e"
      d="M55 36v5a10 10 0 0 1-10 10H35l10 6v-3a13 13 0 0 0 13-13v-5Z"
    />
    <path d="M4 63h24a3 3 0 0 0 3-3V42a3 3 0 0 0-3-3h-5v-1a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3Zm25-10h-8a2 2 0 0 1 0-4h8ZM3 38a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v1H4a3 3 0 0 0-1 .171Zm0 4a1 1 0 0 1 1-1h24a1 1 0 0 1 1 1v5h-8a4 4 0 0 0 0 8h8v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z" />
    <path d="M62 1h-8a1 1 0 0 0-1 1H34a5.456 5.456 0 0 0-4.076 1.831l-5.342 6.01A6.252 6.252 0 0 0 23 14v6.871A10 10 0 1 0 40 28a10.123 10.123 0 0 0-.12-1.466l2.643-2.644 1.574-.449A12.068 12.068 0 0 0 51.655 17H53v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM30 36a8 8 0 1 1 4.314-14.728l-.193.193A3.809 3.809 0 0 0 37.99 27.8c0 .066.01.131.01.2a8.009 8.009 0 0 1-8 8Zm5.759-16.173A10 10 0 0 0 31 18.055v-1.641l2.329-2.329 3.855.771.709 2.837ZM51 15a1 1 0 0 0-.929.628 10.043 10.043 0 0 1-6.523 5.89l-1.822.521a.992.992 0 0 0-.433.254l-3.172 3.172A1.829 1.829 0 0 1 35 24.171a1.819 1.819 0 0 1 .535-1.293l4.172-4.171a1 1 0 0 0 .263-.95l-1-4a1 1 0 0 0-.774-.737l-5-1a.994.994 0 0 0-.9.273l-3 3A1 1 0 0 0 29 16v2.051a9.9 9.9 0 0 0-4 1.3V14a4.259 4.259 0 0 1 1.076-2.831l5.342-6.01A3.458 3.458 0 0 1 34 4h19v11Zm10 2h-6V3h6Z" />
    <path d="M30 25a1 1 0 0 1 1 1h2a3 3 0 0 0-2-2.816V22h-2v1.184A2.993 2.993 0 0 0 30 29a1 1 0 1 1-1 1h-2a3 3 0 0 0 2 2.816V34h2v-1.184A2.993 2.993 0 0 0 30 27a1 1 0 0 1 0-2zm15.493 19.13a1 1 0 0 0-1.008.013l-10 6a1 1 0 0 0 0 1.714l10 6A1 1 0 0 0 46 57v-2.035A14.019 14.019 0 0 0 59 41v-5a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v5a6.01 6.01 0 0 1-5 5.917V45a1 1 0 0 0-.507-.87zM53 41v-4h4v4a12.013 12.013 0 0 1-12 12 1 1 0 0 0-1 1v1.234L36.943 51 44 46.766V48a1 1 0 0 0 1 1 8.009 8.009 0 0 0 8-8z" />
  </svg>
)

export default IncomeIcon
